var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThreeDotIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 4,
  height: 16,
  fill: "none",
  viewBox: "0 0 4 16",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M3.2 1.6a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0M3.2 8A1.6 1.6 0 1 1 0 8a1.6 1.6 0 0 1 3.2 0M1.6 16a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2"
})));
export { SvgThreeDotIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/threeDotIcon.svg";